const dialogActivtyXMl =
    `<?xml version="1.0" encoding="utf-8"?>
<androidx.constraintlayout.widget.ConstraintLayout 
    xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto"
    xmlns:tools="http://schemas.android.com/tools"
    android:layout_width="match_parent"
    android:layout_height="match_parent"
    tools:context=".MainActivity">

    <Button
        android:id="@+id/Button"
        android:layout_width="wrap_content"
        android:layout_height="wrap_content"
        android:text="Dialog"
        app:layout_constraintBottom_toBottomOf="parent"
        app:layout_constraintLeft_toLeftOf="parent"
        app:layout_constraintRight_toRightOf="parent"
        app:layout_constraintTop_toTopOf="parent" />

</androidx.constraintlayout.widget.ConstraintLayout>`

const layout_progress =
    `<?xml version="1.0" encoding="utf-8"?>
<LinearLayout xmlns:android="http://schemas.android.com/apk/res/android"
    android:orientation="horizontal"
    android:padding="13dp"
    android:layout_centerHorizontal="true"
    android:layout_width="wrap_content"
    android:layout_height="wrap_content">

    <ProgressBar
        android:id="@+id/loader"
        android:layout_marginEnd="5dp"
        android:layout_width="45dp"
        android:layout_height="45dp" />
    <TextView
        android:layout_width="wrap_content"
        android:text="Loading..."
        android:textAppearance="?android:textAppearanceSmall"
        android:layout_gravity="center_vertical"
        android:id="@+id/loading_msg"
        android:layout_height="wrap_content" />

</LinearLayout>`

const progressActivityKt =
    `package com.example

import androidx.appcompat.app.AppCompatActivity
import android.os.Bundle
import android.widget.Button
import androidx.appcompat.app.AlertDialog

class MainActivity : AppCompatActivity() {

    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)
        val builder = AlertDialog.Builder(this)
        builder.setView(R.layout.layout_progress)
        builder.setCancelable(true)
        val alertDialog: AlertDialog = builder.create()
        findViewById<Button>(R.id.Button).setOnClickListener {
            alertDialog.show()
        }
    }
}`


const layout_loading =
    `<?xml version="1.0" encoding="utf-8"?>
<LinearLayout
    xmlns:android="http://schemas.android.com/apk/res/android"
    android:layout_width="wrap_content"
    android:orientation="horizontal"
    android:padding="4dp"
    android:layout_height="wrap_content">

    <ProgressBar
        android:id="@+id/progressBar"
        style="?android:attr/progressBarStyle"
        android:layout_width="wrap_content"
        android:layout_height="wrap_content"
        android:layout_weight="1" />

    <TextView
        android:id="@+id/textView3"
        android:layout_width="wrap_content"
        android:layout_height="wrap_content"
        android:layout_weight="1"
        android:text="Loading"
        android:textStyle="bold"
        android:padding="8dp"
        android:layout_gravity="center"/>
</LinearLayout>`

const loadingActivityKt =
    `package com.example

import android.app.Dialog
import androidx.appcompat.app.AppCompatActivity
import android.os.Bundle
import android.widget.Button
import android.widget.LinearLayout

class MainActivity : AppCompatActivity() {

    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)
        val loadingDialog = Dialog(this)
        loadingDialog.setContentView(R.layout.layout_loading)
        loadingDialog.window!!.setLayout(
            LinearLayout.LayoutParams.WRAP_CONTENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
        loadingDialog.setCancelable(true)
        findViewById<Button>(R.id.Button).setOnClickListener {
            loadingDialog.show()
        }
    }
}`

const alertActivityKt =
    `package com.example

import androidx.appcompat.app.AppCompatActivity
import android.os.Bundle
import android.widget.Button
import android.widget.Toast
import androidx.appcompat.app.AlertDialog

class MainActivity : AppCompatActivity() {

    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)
        val builder = AlertDialog.Builder(this)
        builder.setTitle("Title")
        builder.setMessage("Message")
        builder.setIcon(android.R.drawable.ic_dialog_alert)
        builder.setPositiveButton("Yes") { _, _ ->
            Toast.makeText(this, "clicked yes", Toast.LENGTH_LONG).show()
        }
        builder.setNeutralButton("Cancel") { _, _ ->
            Toast.makeText(this, "clicked cancel operation cancel", Toast.LENGTH_LONG).show()
        }
        builder.setNegativeButton("No") { _, _ ->
            Toast.makeText(this, "clicked No", Toast.LENGTH_LONG).show()
        }
        val alertDialog: AlertDialog = builder.create()
        alertDialog.setCancelable(false)


        findViewById<Button>(R.id.Button).setOnClickListener {
            alertDialog.show()
        }
    }
}`
const materialAlertActivityKt =
    `package com.example

import androidx.appcompat.app.AppCompatActivity
import android.os.Bundle
import android.widget.Button
import android.widget.Toast
import com.google.android.material.dialog.MaterialAlertDialogBuilder

class MainActivity : AppCompatActivity() {

    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)
        val materialDialog = MaterialAlertDialogBuilder(this)
            .setTitle("Title")
            .setMessage("Message")
            .setIcon(android.R.drawable.ic_dialog_alert)
            .setPositiveButton("Ok") { _, _ ->
                Toast.makeText(this, "clicked ok", Toast.LENGTH_LONG).show()
            }
            .setNegativeButton("Cancel") { _, _ ->
                Toast.makeText(this, "clicked Cancel", Toast.LENGTH_LONG).show()
            }

        findViewById<Button>(R.id.Button).setOnClickListener {
            materialDialog.show()
        }
    }
}`
const materialThemeDialogActivityKt =
    `package com.example

import androidx.appcompat.app.AppCompatActivity
import android.os.Bundle
import android.widget.Button
import android.widget.Toast
import com.google.android.material.dialog.MaterialAlertDialogBuilder

class MainActivity : AppCompatActivity() {

    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)
        var checkedItem = 2
        val items = arrayOf("Light", "Dark", "Auto (System Default)")
        val materialThemeDialog = MaterialAlertDialogBuilder(this)
            .setTitle("Theme")
            .setPositiveButton("Ok") { _, _ ->
                when (checkedItem) {
                    0 -> {
                        Toast.makeText(this, "Light Mode", Toast.LENGTH_LONG).show()
                    }
                    1 -> {
                        Toast.makeText(this, "Dark Mode", Toast.LENGTH_LONG).show()
                    }
                    else -> {
                        Toast.makeText(this, "Auto", Toast.LENGTH_LONG).show()
                    }
                }
            }
            .setSingleChoiceItems(items, checkedItem) { _, which ->
                checkedItem = which
            }
            .setCancelable(false)

        findViewById<Button>(R.id.Button).setOnClickListener {
            materialThemeDialog.show()
        }
    }
}`
const customeDialogActivityKt =
    `package com.example

import android.app.Dialog
import android.content.Context
import androidx.appcompat.app.AppCompatActivity
import android.os.Bundle
import android.view.View
import android.view.inputmethod.InputMethodManager
import android.widget.*
import java.lang.Exception

class MainActivity : AppCompatActivity() {

    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)
        val fileDialog = Dialog(this)
        fileDialog.setContentView(R.layout.layout_custom_dialog)
        fileDialog.window!!.setLayout(
            LinearLayout.LayoutParams.MATCH_PARENT,
            LinearLayout.LayoutParams.WRAP_CONTENT
        )
        val cancelBtn: Button = fileDialog.findViewById(R.id.cancel_btn)
        val saveBtn: Button = fileDialog.findViewById(R.id.save_btn)
        val edFileName: EditText = fileDialog.findViewById(R.id.edFileName)
        val fileTypeRG: RadioGroup = fileDialog.findViewById(R.id.fileTypeGroup)
        var fileTypeStr = "male"
        fileTypeRG.setOnCheckedChangeListener { _: RadioGroup?, checkedId: Int ->
            if (checkedId == R.id.radioMale) {
                fileTypeStr = "male"
            } else if (checkedId == R.id.radioFemale) {
                fileTypeStr = "female"
            }
        }
        cancelBtn.setOnClickListener { v: View ->
            hideKeyboard(this,v)
            fileDialog.dismiss()
        }
        saveBtn.setOnClickListener { v: View ->
            if (edFileName.text.toString().trim().isEmpty()) {
                edFileName.error = "Required"
            } else {
                Toast.makeText(this, edFileName.text.toString() + fileTypeStr, Toast.LENGTH_LONG).show()
            }
            hideKeyboard(this,v)
            fileDialog.dismiss()
        }

        findViewById<Button>(R.id.Button).setOnClickListener {
            fileDialog.show()
        }
    }
    private fun hideKeyboard(context: Context, view: View) {
        try {
            val imm: InputMethodManager =
                context.getSystemService(INPUT_METHOD_SERVICE) as InputMethodManager
            imm.hideSoftInputFromWindow(view.windowToken, 0)
        } catch (ignored: Exception) {
        }
    }
}`

module.exports = {
    dialogActivtyXMl: dialogActivtyXMl,
    layout_progress: layout_progress,
    progressActivityKt: progressActivityKt,
    layout_loading: layout_loading,
    loadingActivityKt: loadingActivityKt,
    alertActivityKt: alertActivityKt,
    materialAlertActivityKt: materialAlertActivityKt,
    materialThemeDialogActivityKt: materialThemeDialogActivityKt,
    customeDialogActivityKt: customeDialogActivityKt
};